
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 30 30"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.619 18.457l-.244.241c-.547.539-1.055 1.044-1.464 1.524C23.523 20.765 26 22.188 26 23c0 1.019-3.883 3-11 3S4 24.019 4 23c0-.812 2.477-2.235 7.089-2.778-.41-.48-.918-.985-1.464-1.524l-.244-.241C5.226 19.167 2 20.696 2 23c0 3.282 6.54 5 13 5s13-1.718 13-5c0-2.304-3.226-3.833-7.381-4.543z"}}),_c('path',{attrs:{"d":"M15 2a8 8 0 0 0-8 8c0 6 7 8 7 12a1 1 0 0 0 2 0c0-4 7-6 7-12a8 8 0 0 0-8-8zm0 10a2 2 0 1 1-.001-3.999A2 2 0 0 1 15 12z"}})])
          )
        }
      }
    